import React from "react"
import NightAuditNoShowsDataTablePresenter from "./NightAuditNoShowsDataTablePresenter"

class NightAuditNoShowsPresenter extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <div>
        <NightAuditNoShowsDataTablePresenter {...this.props} />
      </div>
    );
  };

};

export default NightAuditNoShowsPresenter